import { render, staticRenderFns } from "./RenderMarkdownMessage.vue?vue&type=template&id=42c18c96&scoped=true"
import script from "./RenderMarkdownMessage.vue?vue&type=script&lang=js"
export * from "./RenderMarkdownMessage.vue?vue&type=script&lang=js"
import style0 from "./RenderMarkdownMessage.vue?vue&type=style&index=0&id=42c18c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c18c96",
  null
  
)

export default component.exports